/**
 * Atrasa a propagacao de um valor que muda a cada tecla.
 *
 * Existe para as grids que paginam NO SERVIDOR e tem busca. Ali o termo entra na
 * `queryKey`, e sem atraso cada tecla e' uma chave nova, ou seja um request:
 * digitar "maria" dispara cinco, dos quais quatro sao jogados fora. As duas
 * telas de Troca de Arquivos fazem exatamente isso hoje — nao ha atraso nenhum
 * nelas, e este modulo e' o remedio que elas ainda vao adotar.
 *
 * Nas grids que paginam no CLIENTE nao serve para nada: lá o filtro e' sincrono
 * sobre uma lista que ja esta na memoria, e atrasar so deixaria a tela lenta.
 *
 * O valor CRU continua no input (a digitacao tem que aparecer na hora); o
 * debounced e' o que vai para a consulta. Sao dois estados de proposito — usar o
 * mesmo para os dois faria o campo "engasgar" enquanto o operador digita.
 *
 *   const [busca, setBusca] = useState("");
 *   const buscaDebounced = useDebouncedValue(busca);
 *   useQuery({ queryKey: ["x", buscaDebounced], ... });
 *   <input value={busca} onChange={(e) => setBusca(e.target.value)} />
 */
import { useEffect, useState } from "react";

/** 300ms: rapido o bastante pra nao parecer travado, longo o bastante pra
 *  cobrir a pausa entre teclas de quem digita depressa. */
export const DEBOUNCE_BUSCA_MS = 300;

export function useDebouncedValue<T>(valor: T, ms: number = DEBOUNCE_BUSCA_MS): T {
  const [atrasado, setAtrasado] = useState(valor);

  useEffect(() => {
    // Limpar o timer anterior a cada mudanca e' o que faz o atraso ser "desde a
    // ultima tecla", e nao um tick fixo que dispararia no meio da digitacao.
    const timer = setTimeout(() => setAtrasado(valor), ms);
    return () => clearTimeout(timer);
  }, [valor, ms]);

  return atrasado;
}
